import moment from 'moment';

import {RelativeTimestampTimer} from 'shells/timestamp/relative-timestamp-timer';

import type {LeadSummaryFragment} from 'nutshell-graphql-types';

import {EditableDate} from './editable-date';

type Props = {
    lead: LeadSummaryFragment | null | undefined;
    onUpdateLeadDueDate: (arg1?: Date | null | undefined) => void;
    onUpdateLeadClosedDate: (arg1?: Date | null | undefined) => void;
};

export function LeadCloseDate(props: Props) {
    if (!props.lead) {
        return null;
    }

    if (props.lead.status === 'OPEN') {
        const isPastClosedTime =
            props.lead.anticipatedClosedTime &&
            moment.unix(props.lead.anticipatedClosedTime).isBefore(moment());

        return (
            <RelativeTimestampTimer
                datetime={isPastClosedTime ? props.lead.anticipatedClosedTime : null}
            >
                {({formattedTimestamp}) => (
                    <EditableDate
                        title='Anticipated close date'
                        value={props.lead?.anticipatedClosedTime}
                        // Default to COB today
                        defaultDate={moment(
                            NutshellFrontendSettings.businessHours.end,
                            NutshellFrontendSettings.businessHours.format
                        ).toDate()}
                        emptyText='Add date'
                        onUpdate={props.onUpdateLeadDueDate}
                        warningText={
                            formattedTimestamp ? `Due to close ${formattedTimestamp}` : undefined
                        }
                        saveDateOnYearChange={true}
                        isClearable={true}
                    />
                )}
            </RelativeTimestampTimer>
        );
    }

    if (props.lead.closedTime) {
        return (
            <EditableDate
                title='Closed on'
                value={props.lead.closedTime}
                onUpdate={props.onUpdateLeadClosedDate}
                cannedOptions={['yesterday', 'today']}
                saveDateOnYearChange={true}
            />
        );
    }

    return null;
}
